module.exports = __webpack_public_path__ + "static/media/INDD.58022682.svg";